import { CustomProgressBar } from "components";
import styles from "./styles.module.css";

type LoadingSpinnerPropType = {
  size?: string;
  classes?: string;
};
export function LoadingSpinner({
  size = "lg",
  classes,
}: LoadingSpinnerPropType) {
  const containerClass = `${styles.loadingMain} ${classes}`;
  const spinnerClass = `${styles.spinner} ${styles[size]}`;
  return (
    <div className={containerClass}>
      <div className={spinnerClass}></div>
    </div>
  );
}

export function LoadingSpinnerProcessing({
  size = "lg",
  classes,
}: LoadingSpinnerPropType) {
  const containerClass = `${styles.loadingMainProcessing} ${classes}`;
  const spinnerClass = `${styles.spinner} ${styles[size]}`;
  return (
    <div className={containerClass}>
      <div className={spinnerClass}></div>
      <span className="text-secondary">Processing…</span>
    </div>
  );
}

type LoadingProgressPropType = {
  size?: string;
  classes?: string;
  progress?: number;
};

export function LoadingSpinnerWithProgress({
  size = "lg",
  classes,
  progress,
}: LoadingProgressPropType) {
  const containerClass = `${styles.loadingMainUploading} ${classes}`;

  return (
    <div className={containerClass}>
      <span className="text-secondary">Uploading…</span>
      <div className="w-80">
        <CustomProgressBar progress={progress} color="#3bb639" />
      </div>
    </div>
  );
}
